import Button from './atoms/Button';
import { formatCurrency } from '../utils/shared';
import EventDTO, { EventPublicStatus } from '../models/event';
import getCustomTicketLabel from '../utils/getCustomTicketLabel';
import getCustomTicketGender from '../utils/getCustomTicketGender';
import { IconTicket2 } from './icons';

interface TicketProps {
  price: number;
  onClick: () => void;
  event: EventDTO;
}

const getCustomSoldOutText = (event: EventDTO) => {
  if (event.custom_ticket_label === 'registro') {
    return 'Registro completo';
  }
  return `${getCustomTicketLabel(event, { plural: true, casing: 'first_letter' })} agotad${getCustomTicketGender(event.custom_ticket_label)}s`;
};

const Ticket: React.FC<TicketProps> = ({ price, onClick, event }) => {
  const getPublicStatusText = (eventPublicStatus: EventPublicStatus) => {
    if (event.is_sold_out) {
      return getCustomSoldOutText(event);
    }
    switch (eventPublicStatus) {
      case EventPublicStatus.PendingApproval:
        return 'El evento no ha sido aprobado aún';
      case EventPublicStatus.NoTicketsAvailable:
        return 'No hay entradas disponibles';
      case EventPublicStatus.Expired:
        return 'El evento ha finalizado';
      case EventPublicStatus.Inactive:
        return 'El evento no está activo';
      default:
        return '';
    }
  };

  const getCustomLabelCTA = () => {
    if (event.custom_ticket_label === 'registro') {
      return 'Registrarse';
    }
    return `Comprar ${getCustomTicketLabel(event, { plural: true, casing: 'lower' })}`;
  };

  return (
    <div className="flex flex-col gap-4 md:gap-6 items-center w-full glass-surface py-4">
      {(event.public_status !== EventPublicStatus.Ready || event.is_sold_out) ? (
        <div className={`text-lg font-semibold justify-center text-center mx-2 ${event.is_sold_out ? 'text-error-600' : 'text-text-primary'}`}>{getPublicStatusText(event.public_status)}</div>
      ) : (
        <>
          <div className='flex flex-col gap-2 text-text-primary bg-primary-300/20 rounded-3xl p-1 lg:p-4 w-full'>
            <div className='flex flex-row items-center gap-2 text-lg font-semibold justify-center text-center mx-2'>
              {getCustomTicketLabel(event, { plural: true, casing: 'first_letter' })}
              <IconTicket2 className="w-8 h-8" />
            </div>
            <div className='text-xl font-semibold justify-center text-center mx-2'>
            {getCustomTicketLabel(event, { plural: true, casing: 'first_letter' })} {price ? `desde ${formatCurrency(price, 'no-decimals')}` : 'gratis'}
            </div>
          </div>
          <div className="w-full">
            <Button variant="primary" onClick={onClick}><div className="whitespace-nowrap">{getCustomLabelCTA()}</div></Button>
          </div>
        </>
      )}
    </div>
  );
};

export default Ticket;
